import { useParams } from 'react-router-dom'
import nth from 'lodash/nth'

import UserContext from '@/gf/modules/User'
import useSession from '@/suppliers/hooks/useSession'
import useGqlClient from '@/suppliers/hooks/useGqlClient'
import { useUpdateProductMutation, useProductsSearchQuery } from '@/suppliers/_gen/gql'

import Page from '@/gf/components/Page'
import UpdateProduct from '@/gf/components/UpdateProduct'
import Frame from '@/suppliers/components/Frame'
import NotFound from './NotFound'

import type { Product } from '@/types'

const Product = () => {
  const { id } = useParams<{ id: string }>() as { id: string }
  const { user, store } = useSession()
  const client = useGqlClient()
  const variables = { page: 1, filters: [['equals', 'id', id]] }
  const { data, refetch } = useProductsSearchQuery({ variables, client })
  const products = data?.productsSearch.products
  const product = products && (nth(products, 0) || null)
  const [updateProductMutation] = useUpdateProductMutation({ client })

  if (
    product !== undefined &&
    (!product || (!UserContext.isAdmin(user) && product.store.id !== store.id))
  )
    return <NotFound />

  const reloadProduct = () => {
    refetch(variables)
  }

  const breadcrumbs = {
    copy: 'Back to Dashboard',
    crumbs: [
      { name: 'Products', href: '/products' },
      { name: 'Edit Product', href: `/products/${id}` },
    ],
  }

  return (
    <Frame breadcrumbs={breadcrumbs}>
      <Page title={product?.name || <>Loading&hellip;</>}>
        {product && (
          <UpdateProduct
            product={product}
            updateProductMutation={updateProductMutation}
            reloadProduct={reloadProduct}
          />
        )}
      </Page>
    </Frame>
  )
}

export default Product
